import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
    if (window) {
        // Suppress console logs
        window.console.log = function () { };
        window.console.warn = function () { };
        window.console.info = function () { };
        window.console.error = function () { };
    }

    // Microsoft Clarity analytics (production only)
    (function (c: any, l: Document, a: string, r: string, i: string, t?: HTMLScriptElement, y?: Element) {
        c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
        t = l.createElement(r) as HTMLScriptElement;
        t.async = true;
        t.src = 'https://www.clarity.ms/tag/' + i;
        y = l.getElementsByTagName(r)[0];
        y.parentNode?.insertBefore(t, y);
    })(window, document, 'clarity', 'script', 'y45w5rr5gs');
}

// Register Firebase Messaging Service Worker
if ('serviceWorker' in navigator) {
    navigator.serviceWorker
        .register('firebase-messaging-sw.js', { scope: '/' })
        .then(reg => {
            console.log('✅ Firebase Messaging SW registered', reg);
            // Ensure service worker is active
            if (reg.active) {
                console.log('✅ Firebase Messaging SW is active');
            } else if (reg.installing) {
                reg.installing.addEventListener('statechange', function () {
                    if (this.state === 'activated') {
                        console.log('✅ Firebase Messaging SW activated');
                    }
                });
            }
        })
        .catch(err => {
            console.error('❌ Firebase Messaging SW registration failed', err);
            // Retry registration after delay
            setTimeout(() => {
                navigator.serviceWorker
                    .register('firebase-messaging-sw.js', { scope: '/' })
                    .then(reg => console.log('✅ Firebase Messaging SW registered on retry', reg))
                    .catch(retryErr => console.error('❌ Firebase Messaging SW retry failed', retryErr));
            }, 3000);
        });
}



platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));

